import { KeyFigureType } from '@/services/rake/rake-types';
import CountUp from 'react-countup';
import { Card, CardBody, Col, ColProps } from 'reactstrap';

const KeyFigureStatic: React.FC<{ item?: KeyFigureType; columnProps?: ColProps }> = ({
  item,
  columnProps = { md: 4, sm: 12 },
}) => {
  if (!item) return <></>;
  return (
    <Col {...columnProps}>
      <Card className={'card-animate bg-' + item.cardColor}>
        <CardBody>
          <div className="d-flex align-middle">
            <div className="flex-grow-1 overflow-hidden">
              <p className="text-uppercase fw-bold text-white-50 text-truncate mb-0">{item.label}</p>
            </div>
          </div>
          <div className="d-flex align-items-bottom justify-content-between mt-4">
            <div>
              <h4 className="fs-22 fw-bold ff-secondary mb-4 text-white">
                <CountUp
                  prefix={item.prefix}
                  suffix={item.suffix}
                  separator={item.separator}
                  end={item.counter}
                  decimals={item.decimals}
                  duration={0.5}
                  preserveValue
                  redraw
                >
                  {({ countUpRef }) => (
                    <span className="counter-value" ref={countUpRef} aria-live="polite" aria-atomic="true" />
                  )}
                </CountUp>
              </h4>
            </div>
            <div className="avatar-sm flex-shrink-0">
              <span className="avatar-title fs-3 rounded bg-white bg-opacity-10">
                <i className={`text-white ${item.icon}`}></i>
              </span>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default KeyFigureStatic;
